<template>
  <div class="all-necessities__container pt-2">
    <div v-if="title" class="all-necessities-header__container">
      <p class="mb-1 py-3">
        <b>{{ title }}</b>
      </p>
    </div>
    <div v-for="(nec, index) in list">
      <div class="necessities__container">
        <div class="d-flex justify-content-between align-items-center">
          <p class="nec__chip">
            {{ index + 1 }}. {{ nec.isStrength ? "Fortaleza" : "Necesidad" }}
          </p>
          <div
            v-if="!ReadOnly"
            class="custom-button-delete"
            @click="() => deleteNecessity(nec)"
          >
            <i
              class="fa fa-times-circle pt-2 pb-2 pr-2 pl-2 custom-icon-x"
              aria-hidden="true"
            />
          </div>
        </div>
        <p>{{ nec.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NecessityStrengthGoalList",
  props: {
    title: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: () => []
    },
    ReadOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    deleteNecessity(nec) {
      if (this.ReadOnly) return;
      this.$emit("delete", nec);
    }
  }
};
</script>
<style scoped>
.all-necessities__container {
  padding: 1px 0;
  background-color: white;
  border-radius: 5px;
}

.all-necessities-header__container {
  border-bottom: 1px solid #d9e5df;
}

.necessities__container {
  border-bottom: 2px solid #d9e5df;
  margin: 10px 0;
}

.nec__chip {
  background-color: #d3e0d9;
  border: 1px solid #aabbb4;
  border-radius: 20px;
  padding: 5px 15px;
  font-weight: bold;
  width: fit-content;
}

.custom-button-delete {
  cursor: pointer;
}

.custom-icon-x {
  color: #c5525d;
  font-size: 24px;
}
</style>
